import React, { useState } from 'react';
import { User } from 'lucide-react';
import DisplayNameField from '../features/profile/DisplayNameField';
import ChangePasswordField from '../features/profile/ChangePasswordField';
import EmailPreferencesField from '../features/profile/EmailPreferencesField';

function ProfilePage({ currentUser }) {
  // Kept locally so the new handle shows immediately; the session payload
  // refreshes on the next load either way.
  const [displayName, setDisplayName] = useState(currentUser?.displayName || '');

  return (
    <div className="page-container fade-in">
      <div className="content-card">
        <div className="card-header">
          <User className="header-icon" size={48} />
          <h1>My Profile</h1>
          <p>View and manage your account</p>
        </div>

        <div className="profile-info">
          <div className="profile-field">
            <span className="field-label">Name:</span>
            <span className="field-value">{currentUser?.firstName} {currentUser?.surname}</span>
          </div>

          <DisplayNameField value={displayName} onChanged={setDisplayName} />
          <div className="profile-field">
            <span className="field-label">Email:</span>
            <span className="field-value">{currentUser?.email}</span>
          </div>
          <div className="profile-field">
            <span className="field-label">Date of Birth:</span>
            <span className="field-value">{currentUser?.dateOfBirth}</span>
          </div>

          {/* Above the password form because it is a set of switches rather than a
              form that expands, and because it is where an unsubscribe link tells
              people to come looking. */}
          <EmailPreferencesField />

          {/* Last, because it expands into a form - anywhere higher and opening
              it shoves the rows people came to read down the page. */}
          <ChangePasswordField />
        </div>
      </div>
    </div>
  );
}

export default ProfilePage;
